import { render } from "./statusSelectDropdown.vue?vue&type=template&id=24c5c22d&scoped=true"
import script from "./statusSelectDropdown.vue?vue&type=script&lang=js"
export * from "./statusSelectDropdown.vue?vue&type=script&lang=js"

import "../less/select.less?vue&type=style&index=0&id=24c5c22d&scoped=true&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c5c22d"]])

export default __exports__